import ColorPicker from 'simple-color-picker';

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['branchColor'];

  initialize() {
    this.branchColorTargets.forEach((element) => {
      const picker = element.querySelector('.color-picker');

      element.querySelector('.parts-table__warehouse-table').addEventListener('click', (event) => {
        event.stopPropagation();

        if (picker.classList.contains('is-active')) {
          picker.classList.remove('is-active');
        } else {
          document.querySelectorAll('.color-picker').forEach((el) => el.classList.remove('is-active'));
          picker.classList.add('is-active');
        }
      });

      let colorPicker = new ColorPicker({
        color: element.querySelector('.color-value').value,
        background: 'rgba(69, 69, 69, 0.7)',
        el: picker,
        width: 200,
        height: 200
      });

      colorPicker.onChange(() => {
        element.querySelectorAll('tr').forEach((row) => {
          const color = colorPicker.getHexString();
          const textColor = this.findColorInvert(colorPicker.getRGB());

          element.querySelector('.color-value').value = color;
          element.querySelector('.text_color-value').value = textColor;

          row.style = `background-color: ${color} !important; color: ${textColor}`;
        })
      });
    });
  }

  connect() {
    document.addEventListener('click', this.outsideClickListener);
  }

  disconnect() {
    this.removeClickListener();
  }

  outsideClickListener(event) {
    if (!event.target.closest('.color-picker')) {
      document.querySelectorAll('.color-picker.is-active').forEach((el) =>  {
        el.classList.remove('is-active');
      });
    }
  }

  removeClickListener() {
    document.removeEventListener('click', this.outsideClickListener);
  };

  colorLuminance(colorInRGB) {
    return (
      this.processedColorChannel(colorInRGB.r) * 0.2126
        + this.processedColorChannel(colorInRGB.g) * 0.7152
        + this.processedColorChannel(colorInRGB.b) * 0.0722
    );
  }

  processedColorChannel(channelValue) {
    let value = channelValue / 255;
    if (value < 0.03928) {
      value = value / 12.92;
    } else {
      value = ((value + 0.055) / 1.055) ** 2;
    }

    return value;
  }

  findColorInvert(colorInRGB) {
    if (this.colorLuminance(colorInRGB) > 0.55) {
      return 'rgba(0, 0, 0, 0.7)';
    } else {
      return '#fff';
    }
  }
}
